import { LoginEffects } from './login.effects';
export * from './login.effects';

/**
 * a medida que se van agregando efectos este array debe actualizarce
 */
export const effects: any[] = [
  LoginEffects
];
